import React from 'react'

export function EmptyTable() {
  return (
    <div className='flex items-center justify-center h-96 bg-white px-6 py-4'>
      <h3 className='font-bold text-3xl text-tBlack'>No collections</h3>
    </div>
  )
}
